import styled from '@emotion/styled'

export const Cont = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.fieldRow': {
    flexDirection: 'row !important',
    alignItems: 'center',
    justifyContent:'flex-end',

    'span': {
      marginRight: '1rem',
      justifySelf:'flex-end',
    },

    '.fieldInput':{
      maxWidth:'20rem'
    }
  }
});